<adapt-dialog [maxWidth]="1000"
              [padding]="false"
              [fitHeight]="true">
    <h3 adapt-dialog-title>Edit purpose & vision</h3>
    <dx-tab-panel adapt-dialog-content
                  class="edit-guiding-philosophy-dialog h-100"
                  [items]="guidingPhilosophyTabs"
                  [swipeEnabled]="false"
                  tabsPosition="left"
                  data-test="edit-guiding-philosophy-tab-panel">
        <div *dxTemplate="let part of 'title'">
            {{ part.title }}
        </div>
        <div *dxTemplate="let part of 'item'">
            <adapt-html-editor #focus
                               [(contents)]="part.content"
                               (isValidChange)="part.isEditorValid = $event"></adapt-html-editor>
        </div>
    </dx-tab-panel>
    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="isInvalid"
                                   [saveBlockingClick]="saveAndClose"
                                   (cancelClick)="cancel()"> </adapt-standard-dialog-buttons>
</adapt-dialog>
